// components/SkeletonBox.jsx
import React from 'react';
import './skeletonBox.css';

const SkeletonBox = ({ width = '100%', height = '36px', borderRadius = '4px' }) => {
    return (
        <div
            className="skeleton-box"
            style={{ width, height, borderRadius }}
        />
    );
};

export default SkeletonBox;
